(ns app.front.view.form
  (:require [app.domain.acceptance.model :as acceptance-model]
            [app.domain.form.model :as form-model]
            [app.front.acceptance.components :as acceptance]
            [app.front.acceptance.events :as acceptance-evt]
            [app.front.acceptance.subs :as acceptance-subs]
            [app.front.entities :as entities]
            [app.front.form.personal-id-render] ; This require is needed to get that namespace into the app
            [app.front.form.render :as fr]
            [app.front.form.subs :as form-subs]
            [app.front.form.ventilation-render] ; This require is needed to get that namespace into the app
            [app.front.process :as process]
            [app.front.review-v2.subs :as review-subs]
            [app.front.ui :as ui]
            [app.front.ui.floating-action-bar :as ui-fab]
            [app.front.ui.section :as section]
            [app.front.ui.separator :as ui-sep]
            [app.front.ui.updated :as ui-updated]
            [app.front.util :refer [for-frag]]
            [app.front.view.not-found :as not-found]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as-alias ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::navigate-to-workspace
  (fn [_ [_ workspace-id]]
    {:route/push {:route :view/workspace :params {:workspace-id workspace-id}}}))

(rf/reg-sub ::schema
  (fn [[_ form-id]]
    (rf/subscribe [::entities/entity form-id]))
  (fn [form _]
    (-> form :form/schema :form.schema/data-schema)))

(defn acceptance-buttons [{:keys [target-id form tr form-id]}]
  (let [acceptance (<sub [::acceptance-subs/entity-latest-acceptance form-id])
        review-id  (<sub [::acceptance-evt/review-id-for-new-acceptance form-id])]
    (when (<sub [::process/signal-permitted?
                 target-id
                 [:process.signal/create-acceptance {:target-id form-id}]])
      (let [acceptance-value (:acceptance/value acceptance)
            customer-value   (:acceptance/customer-value acceptance)]
        [:div.flex.text-right.justify-end
         (when (and (<sub [::process/signal-permitted?
                           target-id
                           [:process.signal/create-acceptance-change-request-no-review {:target-id form-id}]])
                    (nil? review-id)
                    (or (not= :acceptance.value/needs-changes acceptance-value)
                        (= :acceptance.customer-value/updated-by-customer customer-value)))
           [:div.acceptance__create-button.modal-wrapper-button
            [acceptance/create-acceptance-button tr form :acceptance.value/needs-changes]])
         (when (not= :acceptance.value/ok acceptance-value)
           [:div.acceptance__create-button
            [acceptance/create-acceptance-button tr form :acceptance.value/ok]])]))))

(defn autosave-info [{:keys [tr form disabled?]}]
  (when (not disabled?)
    [:span.inline-block.my-4
     (if-let [ts (-> form :latest-change :ts)]
       [ui-updated/updated (util/mmap {:verb-tr-key :last-auto-save}
                                      ts)]
       (tr [:auto-save-info]))]))

(defn acceptance [{:keys [form-id tr target-id]}]
  (let [pending-acceptances (<sub [::acceptance-subs/entity-pending-acceptances form-id])]
    (for-frag [acceptance pending-acceptances]
      [:div.flex.mb-2.w-full.bg-grey-tint-20.items-center.rounded
       [:div.flex-1.mr-4
        [acceptance/render-acceptance tr :entity.type/form acceptance]]
       (when (<sub [::process/signal-permitted?
                    target-id
                    [:process.signal/update-acceptance-customer-value
                     {:acceptance-id (:db/id acceptance)}]])
         [:div.mr-4
          [acceptance/acceptance-changes-made-button
           (util/mmap {:acceptance-id     (:db/id acceptance)
                       :process-target-id target-id
                       :pending-left?     (->> pending-acceptances
                                               (some #(and (acceptance-model/acceptance-can-be-responded-to? %)
                                                           (not= (:db/id %) (:db/id acceptance))))
                                               boolean)}
                      tr)]])])))


(defn delete-button [{:keys [form-id tr target-id workspace-id]}]
  (let [signal [:process.signal/delete-form
                (util/mmap form-id)]]
    (when (<sub [::process/signal-permitted? target-id signal])
      [ui/modal-confirmation-button
       (util/mmap {:id                  "delete-form-button"
                   :on-yes-click        (fn []
                                          (>evt [::process/signal
                                                 target-id
                                                 signal
                                                 {:on-success [::navigate-to-workspace workspace-id]}]))
                   :trigger-button-text (tr [:form/delete])}
                  tr)
       (tr [:form/delete-confirm])])))


(defn form-header [{:keys [form-id target-id] :as ctx} _]
  (let [acceptance-buttons-visible? (<sub [::process/signal-permitted?
                                           target-id
                                           [:process.signal/create-acceptance {:target-id form-id}]])
        acceptances-visible?        (seq (<sub [::acceptance-subs/entity-pending-acceptances form-id]))]
    [:div
     (when (or acceptance-buttons-visible? acceptances-visible?)
       [:div
        (when acceptance-buttons-visible?
          [:div.flex.flex-row.gap-2.justify-end.mb-4
           [acceptance-buttons ctx]])
        (when acceptances-visible?
          [acceptance ctx])
        [ui-sep/horizontal-line]])
     [:div.flex.justify-end.gap-2.my-4
      [fr/open-form-for-edit ctx]
      [delete-button ctx]]]))

;;
;; Form:
;;

(defn make-ctx [*initial form]
  (let [form-id (:db/id form)]
    {:target-id        (-> form :entity/parent :db/id)
     :workspace-id     (-> form :entity/parent :entity/parent :workspace/id)
     ;; TODO get rid of entity here - causes all form controls to be redrawn when
     ;;      any value is changed in database
     :form             form
     :form-id          form-id
     :initial?         (swap! *initial #(case %
                                          nil (nil? (:latest-change form))
                                          %))
     :field-config-map (form-model/form->field-config-map form)}))

(rf/reg-sub ::ctx
  (fn [[_ form-id]]
    [(rf/subscribe [::entities/entity form-id])
     (rf/subscribe [::ws-subs/tr])
     (rf/subscribe [:language])
     (rf/subscribe [:session/user])])
  (fn [[form tr lang user] [_ form-id *initial]]
    (merge (make-ctx *initial form)
           (util/mmap {:disabled? (not (<sub [::process/signal-permitted?
                                              (-> form :entity/parent)
                                              [:process.signal/update-form-data {:form-id form-id}]]))}
                      tr lang user))))

(defn print-button [{:keys [form-id tr]}]
  (when ^boolean js/goog.DEBUG
    [:div.form-print.mt-2.mb-8
     (cc/button {:kind             :tertiary
                 :icon             i/print
                 :icon-description (tr [:print-form])
                 :href             (str "/api/command/form/print?form-id=" form-id)}
                (tr [:print-form]))]))

(defn form-confirm-bar [{:keys [tr form-id target-id]}]
  (let [enabled?   (<sub [::form-subs/form-confirmation-active? form-id])
        confirmed? (<sub [::form-subs/form-confirmed? form-id])
        permitted? (<sub [::process/signal-permitted?
                          target-id
                          [:process.signal/confirm-form {:form-id form-id}]])]
    (when (and enabled? (or confirmed? permitted?))
      [:div.flex.flex-row.items-center.justify-end.gap-4.pt-4.border-t.border-ui-gray.border-solid
       (if confirmed?
         [:<>
          [cc/icon {:icon        i/check
                    :description ""
                    :aria-hidden true}]
          [:span.font-semibold.text-green-600 (tr [:wizard/forms-confirmed])]]
         [:<>
          [:span.text-ui-night-sky-80 (tr [:wizard/forms-confirm-disclaimer])]
          (cc/button {:kind     :primary
                      :on-click #(>evt [::process/signal
                                        target-id
                                        [:process.signal/confirm-form {:form-id form-id}]
                                        {:track-save? true}])}
                     (tr [:wizard/forms-confirm-form]))])])))


(defn inline-form [{:keys [form-id wizard?]}]
  (r/with-let [*initial (atom nil)]
    (let [schema-data        (<sub [::schema form-id])
          {:keys [target-id]
           :as   ctx}        (-> (<sub [::ctx form-id *initial])
                                 (assoc :inline? true
                                        :wizard? wizard?))]
      [:div
       [:div.mb-4.flex.w-full
        {:class (if wizard? "justify-end" "justify-between")}
        (when-not wizard?
          [autosave-info ctx])
        [acceptance-buttons ctx]]
       [:div.mb-4
        [acceptance ctx]]
       [fr/open-form-for-edit ctx]
       (fr/render ctx 0 target-id schema-data)
       [form-confirm-bar ctx]
       [print-button ctx]])))


(defn form-navigation-tabs [{:keys [form workspace-id tr]}]
  (let [review-id (<sub [::review-subs/route-review-id])]
    [:div.flex.flex-row.gap-x-4.gap-y-2.flex-wrap
     (for-frag [{form-id :db/id
                 schema  :form/schema} (<sub [::form-subs/application-forms (:entity/parent form)])]
       (let [status (<sub [::form-subs/form-status-color-code form-id])]
         [ui/tag-button
          (merge {:href      (href/href :view/form
                                        {:workspace-id workspace-id
                                         :form-id      form-id}
                                        (when review-id {:review-id review-id}))
                  :selected? (= form-id (:db/id form))
                  :light?    true
                  :status    status}
                 (when (= status :success)
                   {:icon             i/check
                    :icon-description (tr [:ok])}))
          (:form.schema/name schema)]))]))


(defn changes-made-bar-button [{:keys [tr target-id form-id]}]
  (let [acceptance-ids (<sub [::acceptance-subs/entity-respondable-acceptances form-id])]
    (cond
      ;; Multiple change requests: confirm marking all done
      (and (next acceptance-ids)
           (<sub [::process/signal-permitted?
                  target-id
                  [:process.signal/update-acceptance-customer-values-for-form
                   (util/mmap form-id acceptance-ids)]]))
      [ui/modal-confirmation-button
       {:id                  "form-changes-made-all"
        :tr                  tr
        :trigger-button-text (tr [:acceptance/changes-made])
        :trigger-button-opts {:kind :tertiary
                              :icon i/check}
        :modal-title         (tr [:acceptance/changes-made])
        :yes-button-text     (tr [:acceptance/mark-as-done])
        :no-button-text      (tr [:cancel])
        :on-yes-click        #(>evt [::acceptance-evt/mark-all-changes-done
                                     target-id
                                     form-id
                                     acceptance-ids])}
       (tr [:acceptance/mark-multiple-changes-done-confirmation])]

      ;; Single change request: behave exactly like the top-of-form button.
      (and acceptance-ids
           (<sub [::process/signal-permitted?
                  target-id
                  [:process.signal/update-acceptance-customer-value {:acceptance-id (first acceptance-ids)}]]))
      [acceptance/acceptance-changes-made-button (util/mmap {:acceptance-id     (first acceptance-ids)
                                                             :process-target-id target-id
                                                             :button-kind       :tertiary}
                                                            tr)])))


(defn form-navigation-bar [{:keys [tr workspace-id] :as ctx}]
  (let [[prev-id next-id] (<sub [::form-subs/previous-next-forms])
        review-id         (<sub [::review-subs/route-review-id])
        ws-href           (or (<sub [::review-subs/review-back-href])
                              (<sub [::ws-subs/href]))]
    [ui-fab/floating-action-bar {}
     (cc/button
       {:kind       :ghost
        :href       ws-href
        :class-name "hidden sm:flex"}
       (tr [:back-to-workspace]))
     [:div.flex-1]
     [:div.font-semibold.mx-8 [autosave-info ctx]]
     (when (<sub [::ff/enabled? :feature-flag.id/changes-made-in-form-navigation-bar])
       [changes-made-bar-button ctx])
     (when prev-id
       (cc/button
         {:kind       :tertiary
          :href       (href/href :view/form
                                 {:workspace-id workspace-id
                                  :form-id      prev-id}
                                 (when review-id {:review-id review-id}))
          :class-name "hidden md:flex"}
         (tr [:form/previous-form])))
     (if next-id
       (cc/button
         {:kind :primary
          :href (href/href :view/form
                           {:workspace-id workspace-id
                            :form-id      next-id}
                           (when review-id {:review-id review-id}))}
         (tr [:form/next-form]))
       (cc/button
         {:kind :primary
          :href ws-href}
         (tr [:form/close-forms])))]))


(defn form-view [{{{:keys [form-id]} :path} :parameters}]
  (r/with-let [*initial (atom nil)]
    (let [schema-data           (<sub [::schema form-id])
          {:keys [target-id tr]
           :as   ctx}           (<sub [::ctx form-id *initial])
          loading?              (<sub [::ws-subs/loading?])]
      (cond
        loading?
        [:div
         [:div.mb-8
          (cc/skeleton-text {:heading true})]
         [section/section-skeleton]]

        schema-data
        [:div.cloudpermit-page.form-page
         [:h1.font-semibold.mb-6 (tr [:forms-title])]
         [form-navigation-tabs ctx]
         [ui-sep/horizontal-line]
         [form-header ctx schema-data]
         (fr/render ctx 0 target-id schema-data)
         [form-confirm-bar ctx]
         [print-button ctx]
         [form-navigation-bar ctx]]

        :else
        [not-found/not-found-view]))))
